// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__QC4sp","text":"SelectPayment_text__3_7Nr","title":"SelectPayment_title__1JjSZ","btn":"SelectPayment_btn__3mlpL"};